import API from '../utils/api';
import { getAuthHeaders } from '../context/auth/Auth';

export const getLocations = async (): Promise<any> => {
    return await API.get(
        '/locations',
        { headers: { ...getAuthHeaders() }}
    ).then((response) => response.data);
};